import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { DataGrid } from '@monorepo/nova-ui';

export const StyledTradesTable = styled(DataGrid)(({ theme }) => {
  const fontSize11 = theme.typography.pxToRem(11);

  // Update global DataGrid menu styles dynamically with theme changes
  useEffect(() => {
    const updateGlobalMenuStyles = () => {
      const existingStyle = document.querySelector(
        '[data-datagrid-menu-theme]',
      );
      if (existingStyle) {
        existingStyle.remove();
      }

      const style = document.createElement('style');
      style.setAttribute('data-datagrid-menu-theme', 'true');
      style.textContent = `
        .MuiDataGrid-menuList,
        .MuiDataGrid-menu .MuiPaper-root,
        .MuiPopper-root .MuiPaper-root[role="menu"],
        .MuiPopper-root .MuiPaper-root[role="listbox"],
        .MuiSelect-popper .MuiPaper-root,
        .MuiMenu-paper {
          background-color: ${theme.palette.background.paper} !important;
          color: ${theme.palette.text.primary} !important;
          border: 1px solid ${theme.palette.divider} !important;
        }
        .MuiDataGrid-menuList .MuiMenuItem-root,
        .MuiDataGrid-menu .MuiMenuItem-root,
        .MuiPopper-root .MuiMenuItem-root,
        .MuiSelect-popper .MuiMenuItem-root,
        .MuiMenu-paper .MuiMenuItem-root {
          color: ${theme.palette.text.primary} !important;
        }
        .MuiDataGrid-menuList .MuiMenuItem-root:hover,
        .MuiDataGrid-menu .MuiMenuItem-root:hover,
        .MuiPopper-root .MuiMenuItem-root:hover,
        .MuiSelect-popper .MuiMenuItem-root:hover,
        .MuiMenu-paper .MuiMenuItem-root:hover {
          background-color: ${theme.palette.action.hover} !important;
        }
        .MuiDataGrid-menuList .MuiListItemIcon-root,
        .MuiDataGrid-menu .MuiListItemIcon-root,
        .MuiPopper-root .MuiListItemIcon-root,
        .MuiSelect-popper .MuiListItemIcon-root,
        .MuiMenu-paper .MuiListItemIcon-root {
          color: ${theme.palette.text.primary} !important;
        }
        
        /* Column Management Panel - targeting the actual DOM structure with higher specificity */
        .MuiPopper-root.MuiDataGrid-panel,
        .MuiDataGrid-panel,
        div[class*="MuiDataGrid-panel"] {
          background-color: ${theme.palette.background.paper} !important;
          color: ${theme.palette.text.primary} !important;
          border: 1px solid ${theme.palette.divider} !important;
        }
        
        .MuiDataGrid-paper,
        .MuiDataGrid-panelContent,
        div[class*="MuiDataGrid-panelContent"],
        div[class*="genl6-MuiDataGrid-panelContent"] {
          background-color: ${theme.palette.background.paper} !important;
          color: ${theme.palette.text.primary} !important;
        }
        
        .MuiDataGrid-panelHeader,
        .MuiDataGrid-columnsManagementHeader,
        div[class*="MuiDataGrid-columnsManagementHeader"] {
          background-color: ${theme.palette.background.paper} !important;
          color: ${theme.palette.text.primary} !important;
          border-bottom: 1px solid ${theme.palette.divider} !important;
        }
        
        .MuiDataGrid-panelFooter,
        .MuiDataGrid-columnsManagementFooter,
        div[class*="MuiDataGrid-columnsManagementFooter"] {
          background-color: ${theme.palette.background.paper} !important;
          border-top: 1px solid ${theme.palette.divider} !important;
        }
        
        /* Column management form controls - with higher specificity */
        .MuiDataGrid-panelContent .MuiFormControlLabel-root,
        .MuiDataGrid-paper .MuiFormControlLabel-root,
        div[class*="MuiDataGrid-panelContent"] .MuiFormControlLabel-root {
          color: ${theme.palette.text.primary} !important;
          margin: 0 !important;
          padding: 4px 8px !important;
          border-radius: 4px !important;
        }
        
        .MuiDataGrid-panelContent .MuiFormControlLabel-root:hover,
        .MuiDataGrid-paper .MuiFormControlLabel-root:hover,
        div[class*="MuiDataGrid-panelContent"] .MuiFormControlLabel-root:hover {
          background-color: ${theme.palette.action.hover} !important;
        }
        
        .MuiDataGrid-panelContent .MuiFormControlLabel-label,
        .MuiDataGrid-paper .MuiFormControlLabel-label,
        div[class*="MuiDataGrid-panelContent"] .MuiFormControlLabel-label {
          color: ${theme.palette.text.primary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiCheckbox-root,
        .MuiDataGrid-paper .MuiCheckbox-root,
        div[class*="MuiDataGrid-panelContent"] .MuiCheckbox-root {
          color: ${theme.palette.text.secondary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiCheckbox-root.Mui-checked,
        .MuiDataGrid-paper .MuiCheckbox-root.Mui-checked,
        div[class*="MuiDataGrid-panelContent"] .MuiCheckbox-root.Mui-checked {
          color: ${theme.palette.primary.main} !important;
        }
        
        /* Search field in column management - with higher specificity */
        .MuiDataGrid-panelContent .MuiTextField-root .MuiInputBase-root,
        .MuiDataGrid-paper .MuiTextField-root .MuiInputBase-root,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiInputBase-root {
          background-color: ${theme.palette.background.default} !important;
          color: ${theme.palette.text.primary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiTextField-root .MuiInputBase-input,
        .MuiDataGrid-paper .MuiTextField-root .MuiInputBase-input,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiInputBase-input {
          color: ${theme.palette.text.primary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiTextField-root .MuiInputLabel-root,
        .MuiDataGrid-paper .MuiTextField-root .MuiInputLabel-root,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiInputLabel-root {
          color: ${theme.palette.text.secondary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiTextField-root .MuiOutlinedInput-notchedOutline,
        .MuiDataGrid-paper .MuiTextField-root .MuiOutlinedInput-notchedOutline,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.palette.divider} !important;
        }
        
        /* Search icon in column management search field */
        .MuiDataGrid-panelContent .MuiTextField-root .MuiInputAdornment-root,
        .MuiDataGrid-paper .MuiTextField-root .MuiInputAdornment-root,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiInputAdornment-root {
          color: ${theme.palette.text.secondary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiTextField-root .MuiSvgIcon-root,
        .MuiDataGrid-paper .MuiTextField-root .MuiSvgIcon-root,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiSvgIcon-root {
          color: ${theme.palette.text.secondary} !important;
        }
        
        .MuiDataGrid-panelContent .MuiTextField-root .MuiIconButton-root,
        .MuiDataGrid-paper .MuiTextField-root .MuiIconButton-root,
        div[class*="MuiDataGrid-panelContent"] .MuiTextField-root .MuiIconButton-root {
          color: ${theme.palette.text.secondary} !important;
        }
        
        /* Footer buttons - with higher specificity */
        .MuiDataGrid-panelFooter .MuiButton-root,
        .MuiDataGrid-columnsManagementFooter .MuiButton-root,
        div[class*="MuiDataGrid-columnsManagementFooter"] .MuiButton-root {
          color: ${theme.palette.text.primary} !important;
        }
        
        .MuiDataGrid-panelFooter .MuiButton-root:hover,
        .MuiDataGrid-columnsManagementFooter .MuiButton-root:hover,
        div[class*="MuiDataGrid-columnsManagementFooter"] .MuiButton-root:hover {
          background-color: ${theme.palette.action.hover} !important;
        }
      `;
      document.head.appendChild(style);
    };

    updateGlobalMenuStyles();

    // Cleanup function to remove styles when component unmounts
    return () => {
      const existingStyle = document.querySelector(
        '[data-datagrid-menu-theme]',
      );
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [
    theme.palette.background.paper,
    theme.palette.background.default,
    theme.palette.text.primary,
    theme.palette.text.secondary,
    theme.palette.divider,
    theme.palette.action.hover,
    theme.palette.primary.main,
  ]);

  return {
    backgroundColor: 'transparent',
    fontSize: fontSize11,
    marginTop: theme.spacing(2),
    flex: 1,
    minHeight: 0,
    maxHeight: '100%', // Limit table height to prevent excessive scrolling
    width: '100%',
    // Global menu override for DataGrid column menus (portals)
    '& [data-testid="column-menu"]': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      color: `${theme.palette.text.primary} !important`,
    },

    // Cell styles (override nova-ui DataGrid theme focus ring for this table only)
    '& .MuiDataGrid-cell': {
      borderBottom: 'none',
      fontSize: fontSize11,
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },

    // Header styles
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: 'none',
      backgroundColor: theme.palette.background.default,
      fontSize: fontSize11,
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: 'transparent',

      // Make header icons visible on hover in dark mode
      '&:hover': {
        '& .MuiDataGrid-iconButtonContainer': {
          visibility: 'visible',

          '& .MuiIconButton-root': {
            color: theme.palette.text.primary,
            opacity: 1,
          },
        },
        '& .MuiDataGrid-sortIcon': {
          color: theme.palette.text.primary,
          opacity: 1,
        },
        '& .MuiDataGrid-menuIcon': {
          color: theme.palette.text.primary,
          opacity: 1,
        },
        '& .MuiDataGrid-menuIconButton': {
          color: theme.palette.text.primary,
          opacity: 1,
        },
      },

      // Ensure icons are always visible in sorted state
      '&.MuiDataGrid-columnHeader--sorted': {
        '& .MuiDataGrid-sortIcon': {
          color: theme.palette.text.primary,
        },
      },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      backgroundColor: 'transparent',
    },

    // Row styles
    '& .MuiDataGrid-row': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },

    // Footer styles with custom pagination for dark mode visibility and alignment
    '& .MuiDataGrid-footerContainer': {
      borderTop: 'none',
      backgroundColor: 'transparent',
      alignItems: 'center !important',
      display: 'flex !important',

      '& .MuiBox-root': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .MuiTypography-root': {
        color: theme.palette.text.second,
        display: 'flex',
        alignItems: 'center',
      },
      '& .MuiFormControl-root': {
        display: 'flex',
        alignItems: 'center',
        minHeight: 'auto',

        '& .MuiSelect-select': {
          color: theme.palette.text.primary,
          fontFamily: `${theme.typography.fontFamily} !important`,
          fontSize: `${theme.typography.body2.fontSize} !important`,
          fontWeight: 'normal !important',
          padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)} !important`,
          minHeight: 'auto !important',
          lineHeight: '1.5 !important',
          minWidth: `${theme.spacing(5)} !important`,
          width: '50px !important',
          textAlign: 'center !important',
          WebkitFontFeatureSettings: 'normal !important',
          fontFeatureSettings: 'normal !important',
          fontVariant: 'normal !important',
          textRendering: 'auto !important',
          borderRadius: '10px !important',
          border: `1px solid ${theme.palette.text.fourth} !important`,

          '&.MuiInputBase-input': {
            padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)} !important`,
            minWidth: `${theme.spacing(5)} !important`,
            textAlign: 'center !important',
            fontFamily: `${theme.typography.fontFamily} !important`,
            fontSize: `${theme.typography.body2.fontSize} !important`,
          },
        },

        '& .MuiSelect-icon': {
          color: theme.palette.text.primary,
        },

        '& .MuiInput-root': {
          alignItems: 'center',
          minHeight: 'auto',

          '&:before, &:after': {
            display: 'none',
          },
        },
      },
    },
    '& .MuiDataGrid-footerContainer .MuiPaginationItem-root': {
      color: `${theme.palette.text.main} !important`,
      borderColor: `${theme.palette.text.primary} !important`,
      backgroundColor: 'transparent !important',

      '&:hover': {
        backgroundColor: `${theme.palette.action.hover} !important`,
      },

      '&.Mui-selected': {
        color: `${theme.palette.text.opposite} !important`,
        backgroundColor: `${theme.palette.primary.main} !important`,
      },

      '&.MuiPaginationItem-previousNext': {
        backgroundColor: 'transparent !important',
        color: `${theme.palette.text.main} !important`,
        border: 'none !important',

        '&:hover': {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
      },
    },

    // Target menu items for proper display and dark mode dropdown background
    '& .MuiMenu-paper': {
      backgroundColor: `${theme.palette.background.paper} !important`,

      '& .MuiMenuItem-root': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontSize: `${theme.typography.body2.fontSize} !important`,
        color: `${theme.palette.text.primary} !important`,
        fontFeatureSettings: 'normal !important',
        fontVariant: 'normal !important',
        backgroundColor: 'transparent !important',

        '&:hover': {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },

        '&.Mui-selected': {
          backgroundColor: `${theme.palette.action.selected} !important`,
        },
      },
    },

    // Global DataGrid menu styling - targets the portal/popup menu
    '& + .MuiPopper-root': {
      '& .MuiPaper-root': {
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.text.primary} !important`,
        border: `1px solid ${theme.palette.divider} !important`,

        '& .MuiList-root': {
          backgroundColor: `${theme.palette.background.paper} !important`,
          color: `${theme.palette.text.primary} !important`,

          '& .MuiListItem-root': {
            color: `${theme.palette.text.primary} !important`,

            '&:hover': {
              backgroundColor: `${theme.palette.action.hover} !important`,
            },

            '& .MuiListItemIcon-root': {
              color: `${theme.palette.text.primary} !important`,
            },

            '& .MuiListItemText-root': {
              color: `${theme.palette.text.primary} !important`,
            },

            '& .MuiTypography-root': {
              color: `${theme.palette.text.primary} !important`,
            },
          },
        },
      },
    },

    // DataGrid column menu panel styling for dark mode
    '& .MuiDataGrid-panel': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
    },

    '& .MuiDataGrid-panelHeader': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },

    '& .MuiDataGrid-panelContent': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      color: theme.palette.text.primary,

      '& .MuiListItem-root': {
        color: theme.palette.text.primary,

        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },

      '& .MuiListItemIcon-root': {
        color: theme.palette.text.primary,
      },

      '& .MuiListItemText-root': {
        color: theme.palette.text.primary,
      },
    },

    '& .MuiDataGrid-panelFooter': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderTop: `1px solid ${theme.palette.divider}`,
    },

    // Scrollbar styles - dark mode compatible
    '& .MuiDataGrid-virtualScroller': {
      '&::-webkit-scrollbar': {
        width: theme.spacing(0.75),
        height: theme.spacing(0.75),
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.text.fourth || theme.palette.divider,
        borderRadius: theme.spacing(0.375),
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor:
          theme.palette.text.third || theme.palette.text.secondary,
      },
    },

    // Target specific MUI DataGrid scrollbar classes
    '& .MuiDataGrid-scrollbar': {
      '&::-webkit-scrollbar': {
        width: theme.spacing(0.75),
        height: theme.spacing(0.75),
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.text.fourth || theme.palette.divider,
        borderRadius: theme.spacing(0.375),

        '&:hover': {
          backgroundColor:
            theme.palette.text.third || theme.palette.text.secondary,
        },
      },
    },

    '& .MuiDataGrid-scrollbar--vertical': {
      '&::-webkit-scrollbar': {
        width: theme.spacing(0.75),
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.text.fourth || theme.palette.divider,
        borderRadius: theme.spacing(0.375),

        '&:hover': {
          backgroundColor:
            theme.palette.text.third || theme.palette.text.secondary,
        },
      },
    },

    // DataGrid filler for dark mode
    '& .MuiDataGrid-filler': {
      backgroundColor: 'transparent !important',

      '&::-webkit-scrollbar': {
        width: theme.spacing(0.75),
        height: theme.spacing(0.75),
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.text.fourth || theme.palette.divider,
        borderRadius: theme.spacing(0.375),

        '&:hover': {
          backgroundColor:
            theme.palette.text.third || theme.palette.text.secondary,
        },
      },
    },

    // DataGrid scrollbar filler for dark mode
    '& .MuiDataGrid-scrollbarFiller': {
      backgroundColor: 'transparent !important',
    },

    '& .MuiDataGrid-scrollbarFiller--header': {
      backgroundColor: 'transparent !important',
    },
  };
});
